export enum ActionTypes {
  GET_ALL = '@personalization/GET_ALL',
  GET_FAVORITE_GAMES = '@personalization/GET_FAVORITE_GAMES',
}
